import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '../../../public/pb-logo.png'


const _hoisted_1 = {
  key: 0,
  class: "header-component"
}
const _hoisted_2 = { style: {"height":"2.5rem","width":"5.5rem"} }
const _hoisted_3 = {
  key: 1,
  id: "pb-logo",
  src: _imports_0
}
const _hoisted_4 = { class: "site-name" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-clock" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "notifications-alert-dot"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-bell" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "help-icon header-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-question-circle" })
], -1)

import { ref, onMounted, computed, inject, watch } from "vue";
import DxButton from "devextreme-vue/button";
import DxToolbar, { DxItem } from "devextreme-vue/toolbar";
import UserPanel from "@/components/layout/user-panel.vue";
import changePassword from "@/components/user/change-password.vue";
import { useCurrentUserStore } from "@/stores/CurrentUserStore";
import { CurrentUser } from "@/types/user/CurrentUser";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { useTaskListFiltersStore } from "@/stores/lists/TaskListFiltersStore";
import { useApplicantListStore } from "@/stores/lists/ApplicantListStore";
import { useContactListFiltersStore } from "@/stores/lists/ContactListFiltersStore";
import { usePropertyListFiltersStore } from "@/stores/lists/PropertyListStore";
import AcquaintLogo from "@/assets/acquaint-logo.vue";
import { useUserPermissionsStore } from "@/stores/UserPermissionsStore";
import { useAgentsStore } from "@/stores/utility-switching/AgentsStore";
import { useSwitchStatusesStore } from "@/stores/utility-switching/SwitchStatusesStore";
import SystemInfoModal from "@/components/system/system-info-modal.vue";
import EditUserModal from "@/components/user-management/record/edit-user-modal.vue";
import { AppMode } from "@/enums/system/AppMode";
import RecentRecordsPopover from "@/components/recent-records/recent-records-popover.vue";
import { RouteNames } from "@/router/RouteNames";
import { useRouter } from "vue-router";
import { useRecentRecordsStore } from "@/stores/RecentRecordsStore";
import { openUtilitySwitchingHelp } from "@/utils/system/helpViewer";
import displayErrorMessage from "@/utils/ErrorHandling";
import { useContactTypeConfigurationStore } from "@/stores/ContactTypeConfigurationStore";
import { HelpNavigator } from "@/services/HelpNavigator";
import { useAgencyAccountStore } from "@/stores/utility-switching/AgencyAccountStore";
import { useNotificationsStore } from "@/stores/NotificationsStore";
import NotificationsPopup from "@/components/notifications/notifications-popup.vue";
import { SignalRNotification } from "@/types/notifications/SignalRNotification";
import { useRemindersStore } from "@/stores/RemindersStore";
import { useSystemConfigurationStore } from "@/stores/SystemConfigurationStore";
import AiPanel from "@/components/layout/ai-panel.vue";
import { useTabsHelper } from "@/utils/tabs/useTabsHelper";


export default /*#__PURE__*/_defineComponent({
  __name: 'header-toolbar',
  props: {
  /**
   * Determines whether the menu toggle is enabled.
   * @type {boolean}
   * @default false
   */
  menuToggleEnabled: {
    type: Boolean,
    default: false,
  },

  /**
   * The title to be displayed in the component.
   * @type {string}
   * @default ''
   */
  title: {
    type: String,
    default: "",
  },

  /**
   * Function to handle menu toggling.
   * @type {Function}
   * @required
   */
  toggleMenuFunc: {
    type: Function,
    required: true,
  },
},
  setup(__props) {



const tabsHelper = useTabsHelper();
const currentUser = ref<CurrentUser>();
const currentUserStore = useCurrentUserStore();
const taskListFiltersStore = useTaskListFiltersStore();
const applicantListFiltersStore = useApplicantListStore();
const contactListFiltersStore = useContactListFiltersStore();
const propertyListFiltersStore = usePropertyListFiltersStore();
const userPermissionsStore = useUserPermissionsStore();
const agentsStore = useAgentsStore();
const switchStatusesStore = useSwitchStatusesStore();
const acquaintApiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const editUserModalOpen = ref(false);
const openRecordsPopOver = ref(false);
const router = useRouter();
const recentRecordsStore = useRecentRecordsStore();
const contactTypeStore = useContactTypeConfigurationStore();
const agencyAccountStore = useAgencyAccountStore();
const notificationsStore = useNotificationsStore();
const allNotifications = ref<SignalRNotification[]>([]);
const showNotificationsAlertDot = ref(false);
const openNotificationsPopOver = ref(false);
const notificationsCount = ref("0");
const remindersStore = useRemindersStore();
const systemConfigurationStore = useSystemConfigurationStore();

const displayRecordsPopOver = () => {
  openRecordsPopOver.value = !openRecordsPopOver.value;
};

onMounted(async () => {
  // Get Current User details from the Current User store
  currentUser.value = await currentUserStore.getCurrentUserDetails();
});

const helpNavigator = inject("HelpNavigator") as HelpNavigator;

/** Handles the Click event of the Help icon */
const helpIconClick = () => {
  switch (currentUser.value?.appMode) {
    case AppMode.UtilitySwitchingAgent:
    case AppMode.UtilitySwitchingCouncil:
      openUtilitySwitchingHelp();
      break;

    default:
      helpNavigator.LoadHelpTopicFromCurrentRoute();
      break;
  }
};

const notificationsIconClick = () => {
  // Clear the notifications when the icon is clicked so that the red dot is removed.
  allNotifications.value = [];
  openNotificationsPopOver.value = !openNotificationsPopOver.value;
};

const newFeaturesIconClick = () => {
  window.open("https://acquaintweb.scrollhelp.site/home/whats-new");
};

const userMenuItems = computed(() => [
  {
    text: "Profile",
    icon: "fas fa-user",
    onClick: onProfileClick,
  },
  {
    text: "Change Password",
    icon: "fas fa-lock",
    onClick: onChangePasswordClick,
  },
  {
    text: "Configuration",
    icon: "/icons/configuration.svg",
    onClick: onConfigurationClick,
  },
  {
    text: "Purchase SMS Text Credits",
    icon: "far fa-mobile",
    onClick: onSmsTextCreditsClick,
    visible: currentUser.value?.appMode === AppMode.Full,
  },
  {
    text: "Purchase Email Credits",
    icon: "fas fa-envelope",
    onClick: onEmailCreditsClick,
    visible: currentUser.value?.appMode === AppMode.Full,
  },
  {
    text: "Purchase AI Credits",
    icon: "fas fa-microchip-ai",
    onClick: onAICreditsClick,
    visible: currentUser.value?.appMode === AppMode.Full,
  },
  {
    text: "Purchase Signable Credits",
    icon: "/icons/Signable32.png",
    onClick: onSignableCreditsClick,
    visible: currentUser.value?.appMode === AppMode.Full,
  },
  {
    text: "Help",
    icon: "fas fa-question-circle",
    onClick: helpIconClick,
    visible: currentUser.value?.appMode === AppMode.Full,
  },
  {
    text: "What’s New",
    icon: "fas fa-sparkles",
    onClick: newFeaturesIconClick,
    visible: currentUser.value?.appMode === AppMode.Full,
  },
  {
    text: "Contact Us",
    icon: "fas fa-headset",
    onClick: onContactUsClick,
    visible: currentUser.value?.appMode === AppMode.Full,
  },
  {
    text: "System Information",
    icon: "fas fa-info-circle",
    onClick: onSystemInfoClick,
  },
  {
    text: "Logout",
    icon: "fas fa-sign-out-alt",
    onClick: onLogoutClick,
  },
]);

const showChangePasswordModal = ref(false);

function onChangePasswordClick() {
  showChangePasswordModal.value = true;
}

async function onLogoutClick() {
  try {
    await acquaintApiClient.httpPostVoid(`app/auth/logout`, null);
  } catch (err) {
    displayErrorMessage(getErrorMessage(err), 2000);
  }

  tabsHelper.updateBrowserTabCount(-1);
  // Clear all user related caches so they can be populated when the next user logs in
  currentUserStore.clearCache();
  taskListFiltersStore.clearCache();
  applicantListFiltersStore.clearCache();
  contactListFiltersStore.clearCache();
  propertyListFiltersStore.clearCache();
  userPermissionsStore.clearCache();
  agentsStore.clearCache();
  switchStatusesStore.clearCache();
  recentRecordsStore.clearCache();
  contactTypeStore.clearCache();
  agencyAccountStore.clearCache();
  notificationsStore.clearCache();
  remindersStore.clearCache();
  systemConfigurationStore.clearCache();
  acquaintApiClient.logout();
}

function onProfileClick() {
  editUserModalOpen.value = true;
}

const siteName = computed(() => {
  if (!currentUser.value) {
    return "";
  }

  return currentUser.value.branchName
    ? `${currentUser.value.siteName} - ${currentUser.value.branchName}`
    : currentUser.value.siteName;
});

const showSystemInfoModal = ref(false);

/* Handles the System Info menu item click.
 * Needs to be a standard function instead of an arrow function otherwise an error occurs */
function onSystemInfoClick() {
  showSystemInfoModal.value = true;
}

/** Handles the Configuration menu item click. Must be a standard function to avoid DevExpress errors */
function onConfigurationClick() {
  router.push({ name: RouteNames.Configuration });
}

async function onSmsTextCreditsClick() {
  const sitePrefix = await currentUserStore.getSitePrefix();
  const siteId = currentUser.value?.siteID ?? 0;

  window.open(
    `https://payments.acquaintcrm.co.uk/PurchaseSMSTextCredits.aspx?SitePrefix=${sitePrefix}&SiteID=${siteId}`,
  );
}

const onEmailCreditsClick = async () => {
  const sitePrefix = await currentUserStore.getSitePrefix();
  const siteId = currentUser.value?.siteID ?? 0;

  window.open(
    `https://payments.acquaintcrm.co.uk/PurchaseEmailCredits.aspx?SitePrefix=${sitePrefix}&SiteID=${siteId}`,
  );
};

setInterval(() => {
  // Before we update the notifications list, we need to check if the new notifications are different from the old ones. If they are, we must alert the user.
  const newNotifications = notificationsStore.getNotifications();
  if (
    JSON.stringify(newNotifications) !==
      JSON.stringify(allNotifications.value) &&
    newNotifications.length > 0
  ) {
    // Show the red dot on the notifications icon
    showNotificationsAlertDot.value = true;
    notificationsCount.value =
      newNotifications.length > 99 ? "99" : newNotifications.length.toString();
  }

  if (newNotifications.length == 0) {
    showNotificationsAlertDot.value = false;
  }

  allNotifications.value = [...newNotifications];
}, 1000); // 1 minutes

// When the popup is closed, we need to refresh the notifications list so the red dot is removed.
watch(
  () => openNotificationsPopOver.value,
  (value) => {
    if (!value) {
      allNotifications.value = [];
    }
  },
);

const onContactUsClick = () => {
  window.open("https://acquaintweb.scrollhelp.site/home/contact-us");
};

const onAICreditsClick = async () => {
  const sitePrefix = await currentUserStore.getSitePrefix();
  const siteId = currentUser.value?.siteID ?? 0;

  window.open(
    `https://payments.acquaintcrm.co.uk/PurchaseAICredits.aspx?SitePrefix=${sitePrefix}&SiteID=${siteId}`,
  );
};
const onSignableCreditsClick = async () => {
  const sitePrefix = await currentUserStore.getSitePrefix();
  const siteId = currentUser.value?.siteID ?? 0;

  window.open(
    `https://payments.acquaintcrm.co.uk/PurchaseSignableCredits.aspx?SitePrefix=${sitePrefix}&SiteID=${siteId}`,
  );
};

return (_ctx: any,_cache: any) => {
  return (currentUser.value)
    ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
        _createVNode(_unref(DxToolbar), { class: "header-toolbar" }, {
          menuUserItem: _withCtx(() => [
            _createVNode(UserPanel, {
              "menu-items": userMenuItems.value,
              "menu-mode": "list"
            }, null, 8, ["menu-items"])
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(DxItem), {
              visible: __props.menuToggleEnabled,
              location: "before",
              "css-class": "menu-button"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DxButton), {
                  icon: "fas fa-bars",
                  "styling-mode": "text",
                  onClick: __props.toggleMenuFunc
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["visible"]),
            _createVNode(_unref(DxItem), { location: "before" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  (currentUser.value?.appMode === _unref(AppMode).Full)
                    ? (_openBlock(), _createBlock(AcquaintLogo, { key: 0 }))
                    : (_openBlock(), _createElementBlock("img", _hoisted_3))
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(DxItem), { location: "center" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, _toDisplayString(siteName.value), 1)
              ]),
              _: 1
            }),
            (currentUser.value?.appMode === _unref(AppMode).Full)
              ? (_openBlock(), _createBlock(_unref(DxItem), {
                  key: 0,
                  location: "after",
                  class: "header-icon ai-icon"
                }, {
                  default: _withCtx(() => [
                    _createVNode(AiPanel)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (currentUser.value?.appMode === _unref(AppMode).Full)
              ? (_openBlock(), _createBlock(_unref(DxItem), {
                  key: 1,
                  location: "after"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "recent-records header-icon",
                      onClick: displayRecordsPopOver,
                      id: "recentRecordsIcon"
                    }, _hoisted_6)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (currentUser.value?.appMode == _unref(AppMode).Full)
              ? (_openBlock(), _createBlock(_unref(DxItem), {
                  key: 2,
                  location: "after"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "notifications-icon header-icon",
                      onClick: notificationsIconClick,
                      id: "notificationsIcon"
                    }, [
                      (showNotificationsAlertDot.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(notificationsCount.value), 1))
                        : _createCommentVNode("", true),
                      _hoisted_8
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (currentUser.value?.appMode !== _unref(AppMode).Full)
              ? (_openBlock(), _createBlock(_unref(DxItem), {
                  key: 3,
                  location: "after",
                  onClick: helpIconClick
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_unref(DxItem), {
              location: "after",
              "locate-in-menu": "auto",
              "menu-item-template": "menuUserItem"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_unref(DxButton), {
                    class: "user-button authorization",
                    "styling-mode": "text"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(UserPanel, {
                        "menu-items": userMenuItems.value,
                        "menu-mode": "context"
                      }, null, 8, ["menu-items"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(changePassword, {
          modelValue: showChangePasswordModal.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showChangePasswordModal).value = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(SystemInfoModal, {
          modelValue: showSystemInfoModal.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showSystemInfoModal).value = $event))
        }, null, 8, ["modelValue"]),
        (currentUser.value)
          ? (_openBlock(), _createBlock(EditUserModal, {
              key: 0,
              modelValue: editUserModalOpen.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editUserModalOpen).value = $event)),
              userId: currentUser.value.id
            }, null, 8, ["modelValue", "userId"]))
          : _createCommentVNode("", true),
        _createVNode(RecentRecordsPopover, {
          modelValue: openRecordsPopOver.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((openRecordsPopOver).value = $event)),
          target: "#recentRecordsIcon"
        }, null, 8, ["modelValue"]),
        _createVNode(NotificationsPopup, {
          modelValue: openNotificationsPopOver.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((openNotificationsPopOver).value = $event)),
          target: "#notificationsIcon",
          latestNotifications: allNotifications.value
        }, null, 8, ["modelValue", "latestNotifications"])
      ]))
    : _createCommentVNode("", true)
}
}

})